import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';
import BASE_URL from './config';
import { useToast, ToastContainer } from './Toast';
import AlertModal from './AlertModal';
import logo from './images/logo.png';

function LogInPage() {
  const [user, setUser] = useState(null);

  const navigate = useNavigate();

  // Toast and Alert modal state
  const { toasts, showToast, removeToast } = useToast();
  const [alertModal, setAlertModal] = useState({ isOpen: false, title: '', message: '', type: 'info' });
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  // Submit button for form that collects the user's name and email if it is their first time signing in
  const handleSubmit = async (e) => {
      e.preventDefault();

      const userData = {
        username: user,
        name,
        email,
      };

      try {
        // Go to the backend code to add this information to the users database
        const response = await fetch(`${BASE_URL}/newuser`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          // Send this information to the backend
          body: JSON.stringify(userData),
        });
    
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
        }

        const result = await response.json();
        showToast('User logged in successfully!', 'success');

        // Clear form fields
        setName('');
        setEmail('');

        // Redirect to home page after successful profile completion
        navigate('/');

      } catch (error) {
        setAlertModal({
          isOpen: true,
          title: 'Submission Failed',
          message: `Failed to submit user information: ${error.message}`,
          type: 'error'
        });
      }
  };
    
  // Check to see if someone is logged in from the backend
  useEffect(() => {
    // Check login status when the component mounts
    fetch(`${BASE_URL}/check_login`, {
      method: 'GET',
      credentials: 'include'
    })
    .then(response => response.json())
    .then(data => {
      if (data.isLoggedIn) {
        setUser(data.user);
        // If user is already logged in and has a name, redirect to rides page
        if (data.userName) {
          navigate('/rides');
        }
      } else {
        // If no one is logged in, redirect to home
        navigate('/');
      }
    })
  }, [navigate]);

    return (
        <div>
      {/* Navigation bar on top */}
      <header className="header">
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo" />
          <h1>Bulldog Carpool</h1>
        </div>
        {/* Buttons to redirect wherever the user wants to go */}
        <nav className="nav-buttons">
        </nav>
      </header>

      {/* Form Page Content */}
      <div className="new-ride-page">
        <div className="new-ride-form-container">
          <div className="new-ride-form-header">
            <h2>We just need a few more information</h2>
          </div>
          <form onSubmit={handleSubmit} className="new-ride-form">
            <div className="form-group">
              {/* Field to collect user's name */}
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your full name"
                required
              />
            </div>
            <div className="form-group">
              {/* Field to collect user's email */}
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your.email@yale.edu"
                required
              />
            </div>
            <button type="submit" className="submit-button">Complete Login</button>
          </form>
        </div>
      </div>

      {/* Toast notifications */}
      <ToastContainer toasts={toasts} removeToast={removeToast} />

      {/* Alert modal */}
      <AlertModal
        isOpen={alertModal.isOpen}
        onClose={() => setAlertModal({ ...alertModal, isOpen: false })}
        title={alertModal.title}
        message={alertModal.message}
        type={alertModal.type}
      />
    </div>
    );
}

export default LogInPage;
